<script lang="ts">
  import '../tailwind.config.css'

  interface Props {
    children?: import('svelte').Snippet
  }
  let { children }: Props = $props()
</script>

<!--This layout is used as a reset layout for routes that need it-->
{@render children?.()}
